goog.provide("shadow.js.shim.module$$mui$material$ListItem$default");
shadow.js.shim.module$$mui$material$ListItem$default = shadow.js.shim.module$$mui$material$ListItem.default;
